import axios from 'axios'
import qs from 'qs'
import { Notify, Toast, Dialog } from 'vant'

var instance = axios.create({
  baseURL: '/japi',
  timeout: 60000
})

export function goGet(proUrl, myData) {
  return new Promise(function (resolve, reject) {
    let loadingInstance = Toast.loading({duration: 0, forbidClick: true, message: '加载中...'})
    instance.get(proUrl, {
      params: myData,
      paramsSerializer: params => {
        return qs.stringify(params, {indices: false})
      }
    }).then(res => {
      loadingInstance.clear()
      try {
        if (res.status === 200) {
          resolve(res.data)
        } else {
          throw '失败'
        }
      } catch (err) {
        reject(err)
      }
    })
      .catch(() => {
        loadingInstance.clear()
      })
  })
}

export function goPost(proUrl, myData) {
  let loadingInstance = Toast.loading({duration: 0, forbidClick: true, message: '加载中...'})
  return new Promise(function (resolve, reject) {
    instance.post(proUrl, myData)
      .then(res => {
        loadingInstance.clear()
        try {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            throw '失败'
          }
        } catch (err) {
          reject(err)
        }
      })
      .catch(() => {
        loadingInstance.clear()
      })
  })
}

export function showMessage(mesg, type) {
  Notify({
    message: mesg,
    duration: 2000,
    background: type === 'success' ? '#1989fa' : '#f44'
  })
}


export function showMessageDialog({title, mesg, fun}) {
  Dialog.alert({
    title: title ? title : false,
    message: mesg
  }).then(() => {
    if(fun) fun()
  })
}


export function qsParams(params) {
  return qs.stringify(params, {indices: false})
}

export function searchObj(search) {
  // eslint-disable-next-line quotes
  return JSON.parse("{\"".concat(decodeURIComponent(search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"'), "\"}"))
}
